import type { DefaultRootState } from "react-redux";

export const getAgentChatQuery = () => {
  return undefined;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getIsAiAgentInstanceEnabled = (state: DefaultRootState) => {
  return false;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getIsAiAgentFlowEnabled = (state: DefaultRootState) => {
  return false;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getIsAiAgentApp = (state: DefaultRootState) => {
  return false;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getIsCreatingAgent = (state: DefaultRootState) => {
  return false;
};
